import useNewspaperBaseActions from './useNewspaperBaseActions'

export default useNewspaperBaseActions
